import { useTranslation } from 'react-i18next';
import { lowerCase } from 'lodash';

import usePostStartBreak from 'Domain/monitoring/usePostStartBreak';
import { useModal } from 'Store/modal';

const useOpenBreakConfirmation = () => {
  const { t } = useTranslation('dashboard');
  const { onOpenModal } = useModal();
  const { mutate: onPostStartBreak } = usePostStartBreak();

  const getBreakText = (breakDetail) => {
    let texts = {};
    const defaultBreakModalDescText = t('clock_in_view.breakModalDescText', {
      breakName: lowerCase(breakDetail?.name),
      duration: breakDetail?.totalDuration,
    });

    const mealBreakModalDescText = t('clock_in_view.mealBreakModalDescText');

    switch (breakDetail?.code) {
      case 'helpPartner':
        texts = {
          title: t('clock_in_view.breakModalTitleText'),
          desc: t('clock_in_view.breakModalDescText', { breakName: t('clock_in_view.helpPartnerText'), duration: breakDetail?.totalDuration }),
        };
        break;
      case 'toiletBreak':
        texts = {
          title: t('clock_in_view.breakModalTitleText'),
          desc: t('clock_in_view.breakModalDescText', { breakName: t('clock_in_view.toiletBreakText'), duration: breakDetail?.totalDuration }),
        };
        break;
      case 'mealBreak':
        texts = {
          title: t('clock_in_view.breakModalTitleText'),
          desc: mealBreakModalDescText,
        };
        break;
      case 'prayBreak':
        texts = {
          title: t('clock_in_view.breakModalTitleText'),
          desc: t('clock_in_view.breakModalDescText', { breakName: t('clock_in_view.prayBreakText'), duration: breakDetail?.totalDuration }),
        };
        break;
      default:
        texts = {
          title: t('clock_in_view.breakModalTitleText'),
          desc: defaultBreakModalDescText,
        };
        break;
    }

    return texts;
  };

  const onSubmitBreak = ({ breakDetail, monitoringStatus }) => onPostStartBreak({ breakDetail, monitoringStatus });

  const onOpenBreakConfirmationModal = ({ breakDetail, monitoringStatus, customOnSubmitAction }) => {
    const texts = getBreakText(breakDetail);

    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'confirm',
      title: texts.title,
      contentDescription: texts.desc,
      showPrimaryButton: true,
      showSecondaryButton: true,
      secondaryButtonText: t('clock_in_view.secondaryBreakModalButtonText'),
      primaryButtonText: t('clock_in_view.primaryBreakModalButtonText'),
      onClickPrimaryButton: () => {
        onSubmitBreak({ breakDetail, monitoringStatus });
        customOnSubmitAction?.();
      },
    });
  };

  return onOpenBreakConfirmationModal;
};

export default useOpenBreakConfirmation;
